export default __webpack_public_path__ + "static/media/whyus_1.0ccaf811.png";